import { useApp } from '../../context/AppContext';
import { Icons } from '../ui/Icons';

export function Footer() {
  const { openLeadForm } = useApp();
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-plum text-blush">
      <div className="container-rosa py-16 sm:py-20">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
          {/* Brand */}
          <div className="max-w-sm">
            <a href="#top" className="group flex items-center gap-2" aria-label="Rosa home">
              <span className="grid h-10 w-10 place-items-center rounded-xl bg-terracotta/20 font-display text-2xl font-extrabold text-terracotta-soft transition-transform group-hover:scale-105">
                R
              </span>
              <span className="font-display text-2xl font-bold tracking-tight text-blush">Rosa</span>
            </a>
            <p className="mt-5 font-body text-[15px] leading-relaxed text-blush/70">
              One trusted specialist. A safer home. No runaround.
            </p>
            <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-sage/20 px-3.5 py-1.5 font-body text-[13px] font-semibold text-sage-soft">
              <Icons.badge width={16} height={16} />
              Every specialist is CAPS-certified and background-checked.
            </p>
          </div>

          {/* Rosa column */}
          <div>
            <p className="font-body text-xs font-semibold uppercase tracking-[0.2em] text-blush/50">Rosa</p>
            <ul className="mt-4 space-y-3 font-body text-[15px]">
              <li>
                <a href="#how" className="text-blush/70 transition-colors hover:text-blush">
                  How it works
                </a>
              </li>
              <li>
                <a href="#why" className="text-blush/70 transition-colors hover:text-blush">
                  Why Rosa
                </a>
              </li>
              <li>
                <a href="#explore" className="text-blush/70 transition-colors hover:text-blush">
                  Explore the bathroom
                </a>
              </li>
            </ul>
          </div>

          {/* For families column */}
          <div>
            <p className="font-body text-xs font-semibold uppercase tracking-[0.2em] text-blush/50">For families</p>
            <ul className="mt-4 space-y-3 font-body text-[15px]">
              <li>
                <button
                  onClick={() => openLeadForm()}
                  className="cursor-pointer text-blush/70 transition-colors hover:text-blush"
                >
                  Get an assessment
                </button>
              </li>
              <li>
                <a href="#faq" className="text-blush/70 transition-colors hover:text-blush">
                  Help &amp; FAQ
                </a>
              </li>
              <li>
                <a href="#coverage" className="text-blush/70 transition-colors hover:text-blush">
                  Coverage
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 flex flex-col gap-4 border-t border-blush/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 font-body text-sm text-blush/60">
            <span>&copy; {year} Rosa</span>
            <span className="hidden sm:inline text-blush/30">&bull;</span>
            <span>rosahome.com</span>
          </div>
          <p className="max-w-md font-body text-xs leading-relaxed text-blush/50">
            Rosa connects families with vetted local specialists. Homeowners pay nothing.
          </p>
        </div>
      </div>
    </footer>
  );
}
